import { useWidgetContext } from '@dxp-module/common'
import { useCallback, useEffect, useState } from 'react'
import { useGetAuthenticationRegisterFormQuery } from '../../common/graphql/__generated__/graphql.autogenerated'
import {
  CustomformSchemaProps,
  FormSchemaProps,
  SignupFormSchema,
} from '../model/SignupForm'
import collectedFilters from '../../common/services/collectedFilters'

// TODO fix react hook linting error exhaustive-deps
/* eslint-disable react-hooks/exhaustive-deps */
const useRegisterForm = () => {
  const {
    filters: { token },
  } = collectedFilters()
  const { data: dataAuthentication, loading } =
    useGetAuthenticationRegisterFormQuery({
      ...(token && { variables: { dealId: token } }),
    })
  const {
    configuration: { introducedEmail },
  } = useWidgetContext()

  const data = dataAuthentication?.authentication?.registerForm

  const [schema, setSchema] = useState()
  const [formData, setFormData] = useState<SignupFormSchema | null>()
  const [uiSchema, setUiSchema] = useState()
  const [requiredFields, setRequiredFields] = useState<string[]>()

  const handleFormChange = useCallback(
    (formData: SignupFormSchema) => {
      setFormData(formData)
    },
    [formData]
  )

  const setRequiredFieldsOnLoad = useCallback(
    (formSchema: string | undefined | null) => {
      if (!formSchema) {
        return
      }
      const parsedFormSchema = JSON.parse(formSchema)
      let required: string[] = parsedFormSchema.required || []
      const parsedFormValues: FormSchemaProps[] | CustomformSchemaProps =
        Object.values(parsedFormSchema.properties)
      parsedFormValues.forEach((item: FormSchemaProps) => {
        return (required = required.concat(item?.required || []))
      })
      setRequiredFields(required)
    },
    []
  )

  useEffect(() => {
    if (!loading && data) {
      const replaceNullValues = data.formData?.replace(/:null/gi, ':""')
      const newJSONFormData = replaceNullValues
        ? JSON.parse(replaceNullValues)
        : null
      const parsedSchema = data.schema ? JSON.parse(data.schema) : {}
      const { properties: schemaProperties } = parsedSchema

      for (const [key, value] of Object.entries<
        CustomformSchemaProps | FormSchemaProps
      >(schemaProperties)) {
        if ('properties' in value) {
          for (const [propKey, { default: defaultValue }] of Object.entries<
            CustomformSchemaProps | FormSchemaProps
          >(value.properties)) {
            if (
              newJSONFormData[key]?.[propKey] === '' &&
              defaultValue != null
            ) {
              newJSONFormData[key][propKey] = defaultValue
            }
          }
        } else if (
          newJSONFormData[key] === '' &&
          schemaProperties[key].default != null
        ) {
          newJSONFormData[key] = schemaProperties[key].default
        }
      }

      const formDataPrefilled: SignupFormSchema = introducedEmail
        ? {
            ...newJSONFormData,
            nameInfo: {
              ...formData?.nameInfo,
              uniqueUserEmail: introducedEmail,
            },
          }
        : newJSONFormData

      setSchema(parsedSchema)
      setFormData(formDataPrefilled)
      setUiSchema(data.uiSchema ? JSON.parse(data.uiSchema) : {})

      setRequiredFieldsOnLoad(data.schema)
    }
  }, [loading, introducedEmail])

  const parsedSchemaForm = {
    schema,
    uiSchema,
    formData,
  }

  return {
    registerForm: parsedSchemaForm,
    requiredFields,
    handleFormChange,
  }
}

export default useRegisterForm
